import _ from 'lodash';
import { connect } from 'react-redux';

import MemberBox from '../../components/member-box';
import { followOrUnfollow, openChat } from '../../state/members/actions';
import {
  getCurrentMemberId,
  showAsBlocked,
  findMemberByUid,
  getViewedMemberBlocked,
} from '../../state/members/selectors';
import { isSocial, getIsRtlLocale, isSocialChatInstalled, isExperimentEnabled } from '../../state/site/selectors';
import { getMemberBoxRolesActions } from '../../state/roles/selectors';
import { getGlobalSettings, getComponentSettings } from '../../selectors/settings-selectors';
import withTranslate from '../../hoc/with-translate';
import { getMemberBadgesSettings } from '../../state/badges-definitions/selectors';
import { membersHaveBadge } from '../../selectors/badges';

import defaultParams from '../../constants/wix-params/default-values';
import WIX_PARAM from '../../constants/wix-params/keys';
import { Experiments } from '../../constants/experiments';

const getShowFollowButton = (state, uid) => {
  const showFollowButtonSetting =
    getComponentSettings(state).showFollowButton ?? defaultParams[WIX_PARAM.SHOW_FOLLOW_BUTTON];

  return (
    showFollowButtonSetting &&
    !getViewedMemberBlocked(state, uid, isExperimentEnabled(state, Experiments.USE_VIEWED_MEMBER_BLOCKED))
  );
};

const mapStateToProps = (state, ownProps) => {
  const props = _.pick(ownProps, [
    'goToFFPage',
    'goToMemberPage',
    'layoutStyle',
    'exitModal',
    'className',
    'onRoleAction',
  ]);

  const member = findMemberByUid(state, ownProps.memberId, ownProps.t);
  const currentMemberUid = getCurrentMemberId(state);
  const globalDefaultCoverUrl = getGlobalSettings(state).defaultProfileCoverUrl;
  const localDefaultCoverUrl = getComponentSettings(state).defaultCoverPhotoUrl;
  const defaultCoverUrl = localDefaultCoverUrl ?? globalDefaultCoverUrl;

  const showChat =
    isSocialChatInstalled(state) &&
    (getComponentSettings(state).showMessageButton ?? defaultParams[WIX_PARAM.SHOW_MESSAGE_BUTTON]);

  const showBadges = getComponentSettings(state).showBadges ?? defaultParams[WIX_PARAM.SHOW_BADGES];

  const showFollowers = getGlobalSettings(state).ffLightboxEnabled
    ? getGlobalSettings(state).ffLightboxInstalled ?? false
    : getComponentSettings(state).showFollowersFollowing ?? defaultParams[WIX_PARAM.SHOW_FOLLOWERS_FOLLOWING];

  const membersHaveBadges = membersHaveBadge(state);

  return {
    member,
    pictureStyle: getComponentSettings(state).pictureStyle,
    showCover: getComponentSettings(state).showCover,
    currentMemberUid,
    isSocial: isSocial(state),
    showFollowers,
    showAsBlocked: showAsBlocked(
      state,
      ownProps.memberId,
      isExperimentEnabled(state, Experiments.HIDE_SUSPENDED_LABEL_FOR_NON_OWNERS),
    ),
    rolesActions: getMemberBoxRolesActions(state, ownProps.memberId, showChat),
    badgesSettings: getMemberBadgesSettings(state, ownProps.memberId),
    isRtlLocale: getIsRtlLocale(state),
    showChat,
    defaultCoverUrl,
    showFollowButton: getShowFollowButton(state, ownProps.memberId),
    showBadges,
    membersHaveBadges,
    ...props,
  };
};

const mapDispatchToProps = {
  followOrUnfollow,
  handleChat: (memberId) => openChat(memberId),
};

export default _.flowRight(withTranslate, connect(mapStateToProps, mapDispatchToProps))(MemberBox);
